
import Vue from "vue";
import GenericButton from "@/components/GenericButton.vue";

declare interface ComponentData {
  startAnimation: boolean;
  leftView: boolean;
}

export default Vue.extend({
  data(): ComponentData {
    return {
      startAnimation: false,
      leftView: false,
    };
  },
  props: {
    progress: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    // When component gets mounted, set the startAnimation flag to true,
    // so the class is being applied to the progressbar inside the button
    this.startAnimation = true;
    // When component gets mounted, start the timer for the redirect
    this.startRedirectTimer(10);
  },
  methods: {
    startRedirectTimer(seconds: number): void {
      let milliseconds = seconds * 1000;
      setTimeout(() => {
        // When leftView flag is false, the redirect is not executed after the timeout
        if (!this.leftView) {
          this.$router.push({ name: "dashboard" });
        }
      }, milliseconds);
    },
  },
  beforeDestroy(): void {
    // When the user has left the page, the leftView flag is set to true,
    // so that the timeout does not trigger redirection
    this.leftView = true;
  },
  components: {
    GenericButton,
  },
});
